<template>
  <v-card>
    <v-card-title>
      <div class="headline">
        Сменить пароль пользователя {{ user.username }}
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="passwordChangeForm">
        <v-container>
          <v-row>
            <v-text-field
              v-model="currentPassword"
              :append-icon="showPassword1 ? 'visibility' : 'visibility_off'"
              :type="showPassword1 ? 'text' : 'password'"
              label="Текущий пароль"
              :error-messages="autherror"
              @click:append="showPassword1 = !showPassword1"
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="newPassword"
              :append-icon="showPassword2 ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.min]"
              :type="showPassword2 ? 'text' : 'password'"
              label="Новый пароль"
              @click:append="showPassword2 = !showPassword2"
            />
          </v-row>
          <v-row>
            <v-text-field
              :append-icon="showPassword3 ? 'visibility' : 'visibility_off'"
              :rules="[rules.required, rules.passwordMatch]"
              :type="showPassword3 ? 'text' : 'password'"
              label="Повторите пароль"
              @click:append="showPassword3 = !showPassword3"
            />
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="blue darken-1"
        text
        @click.native="saveChanges"
      >
        Сохранить
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click.native="cancelEditing"
      >
        Отмена
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ChangePassword',
  props: {
    userData: {}
  },
  data () {
    return {
      user: {},
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,
      autherror: '',
      currentPassword: '',
      newPassword: '',
      rules: {
        required: value => !!value || 'Обязательно для заполнения.',
        min: v => v != null && v.length >= 8 || 'Минимальная длинна 8 символов',
        passwordMatch: v => v === this.newPassword || 'Пароли должны совпадать'
      }
    }
  },
  watch: {
    currentPassword () {
      this.autherror = ''
    }
  },
  mounted () {
    this.user = this.userData
  },
  methods: {
    cancelEditing: function () {
      this.$emit('cancel')
    },
    validate () {
      if (this.$refs.passwordChangeForm.validate()) {
        return true
      }
    },
    saveChanges () {
      if (this.validate()) {
        axios.post('/api/api-token-auth/', {
          username: this.user.username,
          password: this.currentPassword
        }).then((response) => {
          this.user.password = this.newPassword
          this.axios.patch(`/api/users/${this.userData.user_id}/`, this.user)
            .then(() => {
              this.$emit('edited')
            })
            .catch((err) => {
              this.$emit('editError', err.response.data)
            })
        }).catch(() => {
          this.autherror = 'Неверный пароль'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/user/ChangePassword.vue